import React, { useState } from "react";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import { useTableSearch } from "core/Operations/useTableSearch";
import Error404 from "MainPages/ErrorPages/error404";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Edit, PlusCircle } from "react-feather";
import { Link } from "react-router-dom";
import { all_routes } from "Router/all_routes";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import TableTop from "Components/UI/TableTop";
import { useGetEmployeeQuery } from "AppQuries/employee/employee_list";
import Select from "react-select";
import { useGetEmpAdditionsQuery } from "AppQuries/payroll/addition/emp-addition";
import Datatable from "core/pagination/datatable";
import { useGetDeductionsQuery } from "AppQuries/payroll/deduction/get-all-deduction";
import { useGetAllDepartmentQuery } from "AppQuries/master/Department/get-all-departments";
import { useGetAdditionsQuery } from "AppQuries/payroll/addition/get-all-additions";
import { useGetEmpDeductionsQuery } from "AppQuries/payroll/deduction/emp-deduction";
import { format } from "date-fns";
const EmployeeDeductions = () => {
  const userData = useSelector(loggedInUser);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedPayslip, setSelectedPayslip] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const [employeeCode, setEmployeeCode] = useState(0);
  const [departmentCode, setDepartmentCode] = useState(0);
  const [deductionCode, setDeductionCode] = useState(0);
  const {
    data,
    isFetching,
    isError,
    error,
    refetch: getEmpDeductions,
  } = useGetEmpDeductionsQuery(
    {
      companyCode: userData.companyCode,
      locationCode: userData.locationCode,
      typeCode: deductionCode,
      departmentCode: departmentCode,
    },
    {
      enabled: !!deductionCode && !!departmentCode && !!userData?.companyCode,
    }
  );

  console.log(data);

  const deductionData = Array.isArray(data)
    ? data?.map((d, _id) => ({
        ...d,
        id: _id,
      }))
    : [];

  // const { data: employees } = useGetEmployeeQuery();
  const { data: departments } = useGetAllDepartmentQuery({
    companyCode: userData?.companyCode,
    isTrue: true,
  });
  const { data: deductions } = useGetDeductionsQuery({
    companyCode: userData?.companyCode,
    isTrue: true,
  });

  // const employeeOptions = Array.isArray(employees?.data)
  //   ? employees?.data
  //       .filter((d) => d.isActive)
  //       .map((o) => ({
  //         id: o.employeeCode,
  //         label: `${o.uniqueId}-${o.fullName}`,
  //         value: o.employeeCode,
  //       }))
  //   : [];
  console.log(departments);
  const departmentOptions = Array.isArray(departments?.data)
    ? departments?.data
        .filter((d) => d.isActive)
        .map((o) => ({
          id: o.code,
          label: o.description,
          value: o.code,
        }))
    : [];
  const deductionOptions = Array.isArray(deductions?.data)
    ? deductions?.data
        // .filter((d) => d.isActive)
        .map((o) => ({
          id: o.code,
          label: o.description,
          value: o.code,
        }))
    : [];
  const [isFilterVisible, setIsFilterVisible] = useState(false);

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const columns = [
    {
      title: "Employee Name",
      dataIndex: "employeeName",
      sorter: (a, b) => a.employeeName.length - b.employeeName.length,
    },
    {
      title: "Deduction Name",
      dataIndex: "description",
      sorter: (a, b) => a.description.length - b.description.length,
    },

    {
      title: "have CPF",
      dataIndex: "haveCPF",
      sorter: (a, b) => a.haveCPF.length - b.haveCPF.length,
      render: (text, record) => (
        <>
          {text === true && <div className=" bg-lightgreen">Yes</div>}
          {text === false && <div className="bg-lightred">No</div>}
        </>
      ),
    },
    {
      title: "Amount",
      dataIndex: "amount",
      sorter: (a, b) => a.amount.length - b.amount.length,
    },
    {
      title: "Start Date",
      dataIndex: "effectiveDateFrom",
      sorter: (a, b) => a.effectiveDateFrom.length - b.effectiveDateFrom.length,
      render: (text, record) => format(new Date(text), "dd-MM-yyyy"),
    },

    {
      title: "End Date",
      dataIndex: "effectiveDateTo",
      sorter: (a, b) => a.effectiveDateTo.length - b.effectiveDateTo.length,
      render: (text, record) => format(new Date(text), "dd-MM-yyyy"),
    },
    {
      title: "Action",
      dataIndex: "action",
      className: "action-table-data",
      render: (text, record) => (
        <div className="edit-delete-action">
          <div className="input-block add-lists"></div>
          <Link
            className="me-2 p-2"
            to={`${all_routes.edit_emp_deductions}/${record.deductionCode}`}
          >
            <Edit className="feather-edit" />
          </Link>
        </div>
      ),
    },
  ];

  const searchColumns = columns.map((column, index) => column.dataIndex);
  const { searchValue, setSearchValue, filteredData } = useTableSearch(
    deductionData,
    searchColumns
  );
  //   if (isFetching) return <LoadingSpinner />;
  //   if (isError) return <Error404 error={error} />;
  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Employee Deduction Management</h4>
                <h6>Manage Employee Deduction Details</h6>
              </div>
            </div>

            <div className="page-btn">
              <Link
                to={`${all_routes.add_emp_deductions}`}
                className="btn btn-added"
              >
                <PlusCircle className="me-2" />
                Add New Deductions
              </Link>
            </div>
          </div>

          <div className="card table-list-card border-0">
            <div className="card-body">
              <TableTop
                onSearch={setSearchValue}
                toggleFilterVisibility={toggleFilterVisibility}
                isFilterVisible={isFilterVisible}
                showToggle={true}
              />
              <div
                className={`card${isFilterVisible ? " visible" : ""}`}
                id="filter_inputs"
                // style={{ display: isFilterVisible ? "block" : "none" }}
              >
                
                <div className="card-body pb-0">
                  <div className="form-row row">
                    <div className="row">
                      <div className="col-lg-3 col-sm-6 col-12 mb-3">
                        <div className="form-group">
                          <label className="form-label">Deductions </label>

                          <Select
                            className="select"
                            options={deductionOptions}
                            placeholder="Deduction"
                            value={deductionOptions.find(
                              (option) => option.value === employeeCode
                            )}
                            onChange={(e) => {
                              setDeductionCode(e?.value || 0);
                            }}
                            isClearable
                            //   styles={{
                            //     control: (baseStyles, state) => ({
                            //       ...baseStyles,
                            //       fontSize: "12px",
                            //       width: "100px",
                            //     }),
                            //   }}
                          />
                        </div>
                      </div>

                      <div className="col-lg-3 col-sm-6 col-12 mb-3">
                        <div className="form-group">
                          <label className="form-label">Department </label>

                          <Select
                            className="select"
                            options={departmentOptions}
                            placeholder="Department"
                            value={departmentOptions.find(
                              (option) => option.value === employeeCode
                            )}
                            onChange={(e) => {
                              setDepartmentCode(e?.value || 0);
                            }}
                            isClearable
                            //   styles={{
                            //     control: (baseStyles, state) => ({
                            //       ...baseStyles,
                            //       fontSize: "12px",
                            //       width: "100px",
                            //     }),
                            //   }}
                          />
                        </div>
                      </div>

                      <div className="col-lg-3 col-sm-6 col-12">
                        <div className="input-blocks">
                          <label className="form-label">&nbsp;</label>
                          <Link
                            className="btn btn-filters ms-auto"
                            onClick={getEmpDeductions}
                            type="button"
                          >
                            <i
                              data-feather="search"
                              className="feather-search"
                            />
                            {/* {isFetching ? (
                              <>
                                <i className="fas fa-spinner fa-spin me-2"></i>
                                Loading...
                              </>
                            ) : ( */}
                            <>Filter</>
                            {/* )} */}
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="table-responsive">
                <Datatable
                  columns={columns}
                  dataSource={filteredData}
                  rowKey={(record) => record.key}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EmployeeDeductions;
